export const NET_ID = { blockchain: 'Internet Computer', network: '00000000000000020101', };
export const ROSETTA_URL = 'https://rosetta-api.internetcomputer.org';